import React from "react";

export default class FirstPage extends React.PureComponent {
  render() {
    return (
      <div>
        <div className="padding-vert">
          <h2 ref="gallery" className="feature">One Stop Shop for</h2>
        </div>
        <div className="header-overlay2">
          <h1 className="brand-name">All Networking Solutions</h1>
        </div>
      </div>
    );
  }
}